var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLoanServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 112,
    viewBox: "0 0 179 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2025_490)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.6157,
    y: 39.3252,
    width: 81.1181,
    height: 17.0775,
    rx: 8.53875,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4104,
    y: 50.0615,
    width: 79.8324,
    height: 23.8635,
    rx: 11.9318,
    transform: "rotate(-35 33.4104 50.0615)",
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6157,
    y: 56.4023,
    width: 93.9262,
    height: 17.0775,
    rx: 8.53875,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6157,
    y: 73.4805,
    width: 85.3875,
    height: 17.0775,
    rx: 8.53875,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6157,
    y: 90.5576,
    width: 76.8487,
    height: 17.0775,
    rx: 8.53875,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.1545,
    cy: 71.3453,
    rx: 34.155,
    ry: 36.2897,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6147,
    y: 35.0537,
    width: 81.1181,
    height: 17.0775,
    rx: 8.53875,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4106,
    y: 45.79,
    width: 79.8324,
    height: 23.8635,
    rx: 11.9318,
    transform: "rotate(-35 33.4106 45.79)",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6147,
    y: 52.1309,
    width: 93.9262,
    height: 17.0775,
    rx: 8.53875,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6147,
    y: 69.209,
    width: 85.3875,
    height: 17.0775,
    rx: 8.53875,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6147,
    y: 86.2861,
    width: 76.8487,
    height: 17.0775,
    rx: 8.53875,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.1545,
    cy: 67.0739,
    rx: 34.155,
    ry: 36.2897,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.0394,
    cy: 70.4444,
    rx: 29.8856,
    ry: 23.4816,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.0394,
    cy: 66.1749,
    rx: 29.8856,
    ry: 23.4816,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.216 75.3467L77.7953 52.7073H83.2154L87.2179 68.6341H87.4264L91.4706 52.7073H96.849L100.935 68.5507H101.143L105.104 52.7073H110.524L104.104 75.3467H98.5585L94.3058 60.0036H94.0139L89.7612 75.3467H84.216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2025_490",
    x: -2.00635,
    y: 0,
    width: 183,
    height: 114.006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2025_490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2025_490",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoanServiceMain);
export default __webpack_public_path__ + "static/media/IcLoanServiceMain.9fa90c603cb8d3e30a1b3e6165f8aea8.svg";
export { ForwardRef as ReactComponent };